import React from "react";
import { Link } from "react-router-dom";
import Page from "../components/Page";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

export default function Privacy() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Politika e privatësisë — Amora Weddings" : "Privacy Policy — Amora Weddings");

  return (
    <Page title={sq ? "Politika e privatësisë" : "Privacy Policy"} narrow>
      <p className="updated">{sq ? "Përditësuar së fundi: 2026" : "Last updated: 2026"}</p>

      {sq ? (
        <>
          <h2>1. Çfarë mbledhim</h2>
          <p>Për bizneset: emailin, emrin e biznesit, kontaktet, fotot dhe detajet që ngarkon. Për çiftet: lista e bizneseve të ruajtura mbahet vetëm në pajisjen tënde (local storage), jo në serverët tanë. Mbledhim gjithashtu të dhëna teknike bazë dhe statistika anonime të shikimeve e kontakteve.</p>

          <h2>2. Si i përdorim</h2>
          <p>Të dhënat përdoren për të menaxhuar listimet, për të mundësuar kontaktin mes çifteve dhe bizneseve, për të dërguar njoftime për llogarinë tënde, dhe për të përmirësuar platformën.</p>

          <h2>3. Palët e treta</h2>
          <p>Përdorim shërbime të besuara për të mbajtur platformën në punë: Google Firebase (llogari dhe bazë të dhënash), Cloudinary (ruajtja e fotove) dhe EmailJS (njoftimet me email). Këto shërbime përpunojnë të dhëna sipas politikave të tyre.</p>

          <h2>4. Ruajtja</h2>
          <p>Të dhënat e biznesit ruhen për aq kohë sa llogaria është aktive. Mund të kërkosh fshirjen e llogarisë dhe të dhënave të tua në çdo kohë.</p>

          <h2>5. Të drejtat e tua</h2>
          <p>Ke të drejtë të kërkosh qasje, korrigjim ose fshirje të të dhënave të tua. Për përdoruesit në BE/diasporë, zbatohen të drejtat sipas GDPR-së. Për të ushtruar këto të drejta, <Link to="/contact">na kontakto</Link>.</p>

          <h2>6. Cookies dhe local storage</h2>
          <p>Përdorim local storage për të ruajtur listën tënde të bizneseve të preferuara dhe gjuhën e zgjedhur. Nuk përdorim cookies gjurmuese për reklama.</p>

          <h2>7. Fëmijët</h2>
          <p>Platforma nuk synohet për përdorues nën moshën 16 vjeç.</p>

          <h2>8. Ndryshimet</h2>
          <p>Mund ta përditësojmë këtë politikë. Versioni më i fundit do të jetë gjithmonë në këtë faqe.</p>

          <h2>9. Kontakti</h2>
          <p>Për pyetje rreth privatësisë, <Link to="/contact">na kontakto</Link>.</p>
        </>
      ) : (
        <>
          <h2>1. What we collect</h2>
          <p>For businesses: your email, business name, contact details, photos and the details you upload. For couples: your saved list of businesses is stored only on your device (local storage), not on our servers. We also collect basic technical data and anonymous view/contact statistics.</p>

          <h2>2. How we use it</h2>
          <p>Data is used to manage listings, to enable contact between couples and businesses, to send notifications about your account, and to improve the platform.</p>

          <h2>3. Third parties</h2>
          <p>We use trusted services to run the platform: Google Firebase (accounts and database), Cloudinary (photo storage) and EmailJS (email notifications). These services process data under their own policies.</p>

          <h2>4. Retention</h2>
          <p>Business data is kept for as long as the account is active. You can request deletion of your account and data at any time.</p>

          <h2>5. Your rights</h2>
          <p>You have the right to request access, correction or deletion of your data. For users in the EU/diaspora, rights under the GDPR apply. To exercise these rights, <Link to="/contact">contact us</Link>.</p>

          <h2>6. Cookies and local storage</h2>
          <p>We use local storage to keep your list of favorite businesses and your chosen language. We do not use tracking cookies for advertising.</p>

          <h2>7. Children</h2>
          <p>The platform is not intended for users under the age of 16.</p>

          <h2>8. Changes</h2>
          <p>We may update this policy. The latest version will always be on this page.</p>

          <h2>9. Contact</h2>
          <p>For privacy questions, <Link to="/contact">contact us</Link>.</p>
        </>
      )}
    </Page>
  );
}
